<template>
  <div class="white-box position-relative">
    <TileLoader :loading="loading"/>
    <div class="header-container">
      <h2>Paiements</h2>
      <div>
        <strong>Solde : {{ formatEuro(currentBalance) }}</strong>
      </div>
    </div>
    <table class="invoices-table">
      <thead>
      <tr>
        <th>Facture</th>
        <th class="number">Facturé</th>
        <th class="number">Payé</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="invoice of invoices" :key="invoice.Label">
        <td>{{ invoice.Label }}</td>
        <td class="number">{{ formatEuro(invoice.Invoiced) }}</td>
        <td class="number">{{ formatEuro(invoice.Paid) }}</td>
        <td class="tag">
          <div
            :class="Math.abs(invoice.Invoiced - invoice.Paid) < 2 ? 'green' : (invoice.Paid > 0 || !invoice.due) ? 'orange' : 'red'">
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

</template>

<script>
import TileLoader from "../../Dashboards/TileLoader.vue";
import {getPaymentsFrs} from "@/utils/dashboardCdm";
import dayjs from "dayjs";

export default {
  components: {TileLoader},
  name: 'FrsPaymentsTile',
  props: ["frsGuid"],
  data() {
    return {
      loading: 0,
      invoices: []
    }
  },
  mounted() {
    this.initData();
  },
  watch: {
    frsGuid() {
      this.initData();
    }
  },
  methods: {
    initData() {
      if (!this.frsGuid) return;

      this.loading = 1;
      getPaymentsFrs(this.frsGuid).then(res => {
        if (res.length) {
          this.invoices = res.map(invoice => {
            invoice.due = false;

            if (invoice.InvoiceType == 2) {
              // Il s'agit de RFA (acomptes ou annuelle)
              let dueDates = {
                4: dayjs().year(invoice.Year).month(4).date(15).endOf('day'),
                7: dayjs().year(invoice.Year).month(7).date(15).endOf('day'),
                10: dayjs().year(invoice.Year).month(10).date(15).endOf('day'),
                12: dayjs().year(invoice.Year + 1).month(1).date(28).endOf('day'),
              };

              if (dayjs().isAfter(dueDates[invoice.Month]))
                invoice.due = true;
            } else {
              // On gère les prestations : due à 45 jours fin de mois à date d'émission
              let dueDate = dayjs(invoice.CreatedAt).add(45, 'day').endOf('month');
              if (dayjs().isAfter(dueDate))
                invoice.due = true;
            }

            return invoice;
          });
        }
        this.loading = 0;
      })
    },
    formatEuro(value) {
      return Intl.NumberFormat('fr-FR', {style: 'currency', currency: 'EUR'}).format(value);
    },
  },
  computed: {
    totalPaid() {
      return this.invoices.reduce((acc, cur) => acc + cur.Paid, 0);
    },
    totalInvoiced() {
      return this.invoices.reduce((acc, cur) => acc + cur.Invoiced, 0);
    },
    currentBalance() {
      return this.totalPaid - this.totalInvoiced;
    }
  }
}
</script>

<style scoped>
.white-box {
  flex: 1 1 25em;
  padding: 12px;

  display: flex;
  flex-direction: column;
}

.header-container {
  display: flex;
  justify-content: space-between;
}

h2 {
  display: flex;
  align-items: center;

  font-size: 20px;
  border-left: 3px solid #A7C13C;
  padding-left: 4px;
}

p {
  margin: 0;
}

.invoices-table thead {
  border-bottom: 1px solid black;
}

.invoices-table th, .invoices-table td {
  padding: 2px 8px;
}

.invoices-table .number {
  text-align: right;
}

.invoices-table .tag > div {
  width: 16px;
  height: 16px;
  border-radius: 50%;
}

.invoices-table .tag > div.green {
  background-color: #388E3C;
}

.invoices-table .tag > div.orange {
  background-color: #FFC107;
}

.invoices-table .tag > div.red {
  background-color: #D32F2F;
}

</style>



// WEBPACK FOOTER //
// src/components/DashboardCdm/RecapPage/FrsPaymentsTile.vue